import styled, {keyframes, css} from 'styled-components';
import React, { Component } from 'react';

const Outline = styled.div`
    padding: 10% 10%;
    padding-bottom: 0;
    width: 80%;
    height:auto;
    font-family:'Gotham Medium';
    background-color: white; 
    background: white;
    z-index: 1;
    overflow:visible;
    @media only screen and (max-width: 900px) {
        padding:10% 2%;
        width: 96%;
    }
`;

const Form = styled.form`
    background:white;
    width:50%;
    height:auto;
    margin-right: 0;
    float:left;
    z-index:2;
    position:relative;
    @media only screen and (max-width: 500px) {
        width:100%;
    }
`;

const FormBackground = styled.div`
    height: 100%;
    width: 100%;
    background-color: white;
    z-index: 5;
    position: relative;
`;

const fillDot = (props) =>  keyframes`
    to {
        width:100%;
        height:100%;
        margin: 0;
        background-color:${(props ?  '#DD9E7C' : '#4E757E')};
    }
`;
const fillDotR = (props) =>  keyframes`
    0% {
        width:100%;
        height:100%;
        margin: 0;
        background-color:${(props ? '#4E757E' : '#DD9E7C')};
    }
    50% {
        width:0;
        height:0;
        margin: 5px;
        background-color:${(props ?  '#DD9E7C' : '#4E757E')};
    }
    100% {
        width:100%;
        height:100%;
        margin: 0;
        background-color:${(props ?  '#DD9E7C' : '#4E757E')};
    }
`;
const fillDotRR = (props) => keyframes`
    0% {
        width:100%;
        height:100%;
        margin: 0;
        background-color:${(props ? '#4E757E' : '#DD9E7C')};
    }
    50% {
        width:0;
        height:0;
        margin: 5px;
        background-color:${(props ?  '#DD9E7C' : '#4E757E')};
    }
    100% {
        width:100%;
        height:100%;
        margin: 0;
        background-color:${(props ?  '#DD9E7C' : '#4E757E')};
    }
`;

const GroupContainer = styled.div`
    width: auto;
    margin: 5px 0;
`; 

const InpDiv = styled.ul`
    height: 50px;
    width: 70%;
    margin: 0px 0px;
    margin-top: 10px;
    padding: 0;
    z-index: 8;
    position: relative;
    background-color: white;
    @media only screen and (max-width: 800px) {
        margin: 0;
        width: 100%;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        margin-top:20px;
    } 
`;

const Input = styled.input`
    height: 50px;
    width: 81%;
    font-size: 15px;    
    float: left;
    padding-left:15px;
    border-radius:30px;
    border-style:none;
    z-index: 8;
    position:relative;
    font-family: 'Gotham Book';
    background-color: ${props => (props.error ? '#f1d8cb' : '#eaf0ed')};
    ::placeholder {
        font-family:'Gotham Book';
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        box-shadow: 0 0 0px 1000px  ${props => (props.error ? '#EFD8CA' : '#EBF0ED')} inset;
        -webkit-box-shadow: 0 0 0px 1000px  ${props => (props.error ? '#EFD8CA' : '#EBF0ED')} inset;
        transition: background-color 5000s ease-in-out 0s;
    }
    @media only screen and (max-width: 800px) {
        width:75%;
    }
    @media only screen and (max-width: 500px) {
        width: 70%;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        height: 100px;
        font-size: 30px;
    } 
`;

const TxtArea = styled.textarea`
    height: 100px;
    width: 81%;
    font-size: 15px;   
    margin: auto; 
    float:left;
    resize:none;
    padding-left:30px;
    padding-right:30px;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius:30px;
    border-style:none;
    z-index: 3;
    position:relative;
    font-family: 'Gotham Book';
    background-color: ${props => (props.error ? '#f1d8cb' : '#eaf0ed')};
    ::placeholder {
        font-family:'Gotham Book';
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        box-shadow: 0 0 0px 1000px  ${props => (props.error ? '#EFD8CA' : '#EBF0ED')} inset;
        -webkit-box-shadow: 0 0 0px 1000px  ${props => (props.error ? '#EFD8CA' : '#EBF0ED')} inset;
        transition: background-color 5000s ease-in-out 0s;
    }
    @media only screen and (max-width: 500px) {
        width: 55%;
        margin: 0 10%;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        height: 200px;
        font-size:30px;
    }
`;

const ImgDiv = styled.div`
    width:40%;
    height:auto;
    float:right;
    margin:auto;
    padding: 5% 5%;
    z-index:20;
    position:relative;
    background-color:white;
    @media only screen and (max-width: 500px) {
        float:left;
        text-align:center;
        width:90%;
        padding:5% 5%;
    }
`;

const MovingImg = styled.img`
    width: 100%;
    height:auto;
    float: right;
    @media only screen and (max-width: 500px){
        width: 100%;
    }
`;

const Dot = styled.div`
    width: 10px;
    height: 10px;
    background: transparent;
    border-color: ${props => (props.error ? '#DD9E7C' : '#4E757E')};
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    margin: 20px 10px;
    float: left;
    text-align: center;  
    @media only screen and (max-width: 500px){
        margin: 20px 5px;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        height: 20px;
        width: 20px;
        margin: 40px 20px;
    } 
`;

const InnerDot = styled.div`
    width: 0;
    height: 0;
    border-radius: 50%;
    margin: 5px;
    animation: ${props => (props.blur ? (() => {
        if(props.ErrorCount === 0) {
            return(css`${fillDot(props.error)} .3s forwards`);
        } else if(props.ErrorCount%2 === 0) {
            return(css`${fillDotR(props.error)} .6s forwards`);
        } else {
            return(css`${fillDotRR(props.error)} .6s forwards`);
        }
    }) : 'none')}; 
`;

const BtnDiv = styled.div`
    height: auto;
    width: 100%;
    margin: 0px 20px;
    margin-top: 10px;
    margin-left: 32px;
    padding:0;
    z-index: 4;
    position: relative;
    background-color: white;
    transform: ${props=> (props.Display ? (props.mI ? 'translateY(0px)' : 'translateY(-300px)') : 'translateY(-500px)')};
    transition-duration:.5s;
    transition-property: transform;
    z-index: 2;
    @media only screen and (max-width: 500px) {
        margin: auto;
        text-align:center;
        margin-top: 5%;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        transform: ${props=> (props.Display ? (props.mI ? 'translateY(0px)' : 'translateY(-380px)') : 'translateY(-700px)')};
    }
`;
const OopsEmail = styled.a`
    color: #DD9E7C;
    text-decoration: none;
    :hover {
        font-size:1.04em;
    }
`;

const HiddenFields = styled.div`
    transform: ${props=> (props.Display ? 'translateY(0px)' : 'translateY(-140px)')};
    transition-duration:.5s;
    transition-property: transform;
    z-index: 1;
    position:relative;
`;

const Button = styled.button`
    height: 50px;
    width: 40%;
    font-size: 15px;
    font-family: 'Gotham Book';
    text-transform: uppercase;
    border-radius: 30px;
    border-style: none;
    margin-top: 20px;
    background-color: rgba(203, 217, 211,.4);
    color: rgb(107,108,109);
    display: block;
    cursor: pointer;
    :focus {
        outline: 0;
    }
    @media only screen and (max-width: 500px){
        margin: 0 10%;
        width: 35%;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        height:100px;
        font-size:30px;
    }

`;

const ErrorLabel = styled.div`
    padding: 5px;
    padding-top: 17.5px;
    padding-bottom: 17.5px;
    padding-left: 15px;
    margin: 0px 40px;
    width:50%;
    height: auto;
    color: rgba(221, 158, 124, 1);
    font-size: 15px;
    text-transform: uppercase;
    font-family: 'Gotham Medium';
    transform: ${props=> (props.error ? 'translateY(0px)' : 'translateY(-50px)')};
    transition-duration:.5s;
    transition-property: transform;
    z-index: 7;
    position:relative;
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        font-size: 30px;
        padding:35px 0 35px 30px;
    } 
`;

const InfoDiv = styled.div`
    border-style: none;
    width: auto;
    margin-top: 10px;
    height: auto;
    background-color:transparent;
    font-size: 15px;
    text-transform: uppercase;
    text-decoration:underline;
    text-decoration-style: solid;
    color: grey;
    float:left;
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        font-size:30px;
    }
`;

const MIBtn = styled.button`
    width:100%;
    background-color: transparent; 
    border-style: none; 
    text-align: center; 
    cursor: pointer;
    :focus {
        outline:0;
    }
    @media only screen and (max-width: 500px) {
        margin: 8px 10%;
        width: 80%;
    }
`;

class InputGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            change: 0
        }
        this.updaterBud = this.updaterBud.bind(this);
    }

    componentDidUpdate(prevProps){
        if((this.props.error !== prevProps.error)) {
            this.updaterBud()
        }
    }
    updaterBud() {
        this.setState(prevstate => ({
            change: prevstate.change + 1
        }));
    }

    render() {
        return(
            <div style={{height:'auto', width:'100%'}}>
                <InpDiv onChange={this.props.onChange}>
                    <div>
                        <Dot error={this.props.error}><InnerDot ErrorCount={this.props.ErrorCount} blur={this.props.blur} id="innerDot" error={this.props.error} /></Dot>
                    </div>
                    <div>
                        <Input name={this.props.name} placeholder={this.props.placeholder} error={this.props.error} onBlur={this.props.onBlur} />  
                    </div>
                </InpDiv>
                <ErrorLabel error={this.props.error}>&#8593; {this.props.msg}</ErrorLabel>
            </div>
        );
    }
}

export function MoreInfo(props) {
    return(
        <MIBtn onClick={props.onClick} type={props.type}>
            <InfoDiv>{props.children}</InfoDiv>
        </MIBtn>
    );
}

export class BoxImg extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps){
    }
    render() {
        return(
            <ImgDiv>
                <MovingImg src="https://d1s0utqm8q1db1.cloudfront.net/images/teal-mom-baby-C.jpg"></MovingImg>
            </ImgDiv>
        );
    }
}

export class SubmitButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            change: 0
        }
    }
    componentDidUpdate(prevProps){
        if((this.props.error !== prevProps.error)) {
            this.updaterBud();
        }
    }
    updaterBud() {
        this.setState(prevstate => ({
            change: prevstate.change + 1
        }));
    }
    render() {
        return(
            <BtnDiv Display={this.props.Display} error={this.props.error} mI={this.props.mI}>
                {this.props.children}
                <MoreInfo type="button" onClick={this.props.moreInfo}>{(this.props.mI ? 'Hide Optional Fields' : 'See Optional Fields' )}</MoreInfo>
                <Button type="submit">Sign Up</Button>
                <br/>
                <ErrLbl error={this.props.responseErr}>{this.props.responseToPost}{(this.props.emailViz ? <OopsEmail href="mailto:stephen@sisterindia.org">Admin</OopsEmail> : '' )}</ErrLbl>
            </BtnDiv>
        );
    }
}

export class hiddenFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            change: 0
        }
    }
    componentDidUpdate(prevProps){
        if((this.props.error !== prevProps.error)) {
            this.updaterBud();
        }
    }
    updaterBud() {
        this.setState(prevstate => ({
            change: prevstate.change + 1
        }));
    }
    render() {
        return(
            <HiddenFields Display={this.props.Display}>
                {this.props.children}
            </HiddenFields>
        );
    }
}

export class ErrLbl extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <ErrorLabel style={{color: css`${(this.props.error ? '#DD9E7C' : '#4E757E')}`, marginTop:'50px'}}>{this.props.children}</ErrorLabel>
            </div>
        );
    }
}

export class NoDotInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            change: 0
        }
        this.updaterBud = this.updaterBud.bind(this);
    }

    componentDidUpdate(prevProps){
        if((this.props.error !== prevProps.error)) {
            this.updaterBud()
        }
    }
    updaterBud() {
        this.setState(prevstate => ({
            change: prevstate.change + 1
        }));
    }

    render() {
        return(
            <div>
                <TxtAreaDiv onChange={this.props.onChange}>
                    <TxtArea name={this.props.name} placeholder={this.props.placeholder} error={this.props.error} onBlur={this.props.onBlur} />  
                </TxtAreaDiv>
                <TxtAreaErrorLabel error={this.props.error}>&#8593; {this.props.msg}</TxtAreaErrorLabel>
            </div>
        );
    }
}

const TxtAreaDiv = styled.div`
    height: 40px;
    width: 70%;
    margin: 0px 0px;
    margin-top: 10px;
    padding: 0;
    z-index: 3;
    position: relative;
    background-color: white;
    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;

const TxtAreaErrorLabel = styled.div`
    padding: 5px;
    padding-top: 17.5px;
    padding-bottom: 17.5px;
    padding-left: 15px;
    margin: 0px 0px;
    width:50%;
    height: auto;
    color: rgba(221, 158, 124, 1);
    font-size: 15px;
    text-transform: uppercase;
    font-family: 'Gotham Medium';
    transform: ${props=> (props.error ? 'translateY(5px)' : 'translateY(-50px)')};
    transition-duration:.5s;
    transition-property: transform;
    z-index: 2;
    position:relative;
    @media only screen and (max-width:500px) {
        margin: 0px 40px;
    }
`;

export {Form, Outline, Dot, GroupContainer, Input, Button, InpDiv, ErrorLabel, FormBackground, InnerDot, InputGroup, OopsEmail}